module.exports = __webpack_public_path__ + "static/abacus-hr-bewerbungsprozess-42ea6d000011d790c291bd06a5fad6db.jpg";